var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { Chevron, DropdownButton, NavigationButton, NavigationLink } from './subcomponents';
const DropdownTrigger = ({ toggleMenu, showActiveStyles, children, dataType, dataReason, isOpen }) => {
    return (_jsx(DropdownButton, Object.assign({ handleComplexTab: toggleMenu, showActiveStyles: showActiveStyles, "data-type": dataType, "data-reason": dataReason, "data-object": dataType && 'link', className: dataType && 'ensightencustomevent', "aria-expanded": isOpen }, { children: children })));
};
const NavigationTab = (_a) => {
    var { label, isDropdown = false, path, menuItems, toggleMenu, isOpen, dataType, dataReason, ariaCurrent } = _a, props = __rest(_a, ["label", "isDropdown", "path", "menuItems", "toggleMenu", "isOpen", "dataType", "dataReason", "ariaCurrent"]);
    const location = useLocation();
    const { pathname } = location;
    const showActiveStyles = () => {
        if (menuItems) {
            return (
            // By default, shouldHighlight is true
            menuItems.some(({ shouldHighlight = true, relPath }) => {
                return relPath === pathname && shouldHighlight;
            }) || !!isOpen);
        }
        return pathname === path;
    };
    const onNavigationTabClick = () => {
        if (toggleMenu)
            toggleMenu();
    };
    return (_jsx(NavigationButton, Object.assign({}, props, { showActiveStyles: showActiveStyles(), onClick: onNavigationTabClick }, { children: isDropdown ? (_jsxs(DropdownTrigger, Object.assign({ showActiveStyles: showActiveStyles(), dataType: dataType, dataReason: dataReason, isOpen: isOpen, "aria-expanded": isOpen }, { children: [label, _jsx(Chevron, {})] }))) : (_jsx(NavigationLink, Object.assign({ showActiveStyles: showActiveStyles(), isInline: true, to: path, "data-type": dataType, "data-reason": dataReason, "data-object": dataType && 'link', className: dataType && 'ensightencustomevent', "aria-current": ariaCurrent }, { children: label }))) })));
};
export default NavigationTab;
//# sourceMappingURL=NavigationTab.js.map